// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__30X9u","buttons":"RemoveExpirationActionButtons_buttons__37sMI"};